import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import ContactForm from '../ContactForm';

const ContactInfo = () => {
  const { contactID } = useParams();
  const { authStore, orgStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [contact, setContact] = useState(null);
  const [dLink, setDLink] = useState('#');
  const [contactAddresses, setContactAddresses] = useState([]);

  const { settings } = orgStore;
  const { ExtSysId } = settings;

  const fetchContact = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/contact/${contactID}`,
      );
      setContact(data);
      setContactAddresses(JSON.parse(data.Addresses));
    } catch (e) {
      console.error(e);
    }
  };

  const fetchContactURL = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/contact-xero-deeplink/${contactID}`,
      );
      setDLink(`https://go.xero.com/Contacts/View/${data.ObjectId}`);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    const initialActions = async () => {
      const requests = [];
      if (ExtSysId > 0) {
        requests.push(fetchContactURL());
      }
      requests.push(fetchContact());
      await Promise.all(requests);
      setLoading(false);
    };
    initialActions();
  }, []);
  if (isLoading || !contact) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <WideBox>
              <ContactForm
                contact={contact}
                contactAddresses={contactAddresses}
                fetchContact={fetchContact}
                deepLink={dLink}
                // buttons={[

                // ]}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default ContactInfo;
